import format from 'date-fns/format';

import serverDate from '@glass/web/modules/dates/serverDate';

const generateBlogPostDate = ({ publishedAt, updatedAt }) => {
  if (!publishedAt && !updatedAt) {
    return null;
  }
  const date = new Date(updatedAt || publishedAt);
  let dateFormat = 'MMMM d';
  if (date.getFullYear() !== new Date(serverDate).getFullYear()) {
    dateFormat += ', yyy';
  }
  return `${updatedAt ? 'Updated ' : ''}${format(date, dateFormat)}`;
};

export default generateBlogPostDate;
